/**
 * Force scroll restore after product back-navigation (mobile-first).
 * Saves Y + product anchor on leave; restores with retries + image settle.
 */
(function () {
  var PREFIX = 'mic:sr:';
  var PENDING = PREFIX + 'pending';

  function isProductPath(pathname) {
    return /\/products\//.test(pathname || '');
  }

  function pageKey(href) {
    try {
      var u = href ? new URL(href, location.origin) : new URL(location.href);
      return u.pathname + u.search;
    } catch (e) {
      return location.pathname + location.search;
    }
  }

  function productPath(href) {
    try {
      return new URL(href, location.origin).pathname;
    } catch (e) {
      return '';
    }
  }

  function read(key) {
    try {
      var raw = sessionStorage.getItem(key);
      return raw ? JSON.parse(raw) : null;
    } catch (e) {
      return null;
    }
  }

  function write(key, value) {
    try {
      sessionStorage.setItem(key, JSON.stringify(value));
    } catch (e) {}
  }

  function remove(key) {
    try {
      sessionStorage.removeItem(key);
    } catch (e) {}
  }

  if ('scrollRestoration' in history) {
    history.scrollRestoration = 'manual';
  }

  function saveNow(anchorHref) {
    if (isProductPath(location.pathname)) return;
    write(PREFIX + pageKey(), {
      y: window.scrollY || window.pageYOffset || 0,
      anchor: anchorHref || null,
      t: Date.now(),
    });
  }

  function markPending() {
    try {
      sessionStorage.setItem(PENDING, pageKey());
    } catch (e) {}
  }

  function findAnchor(href) {
    var path = productPath(href);
    if (!path) return null;
    var links = document.querySelectorAll('a[href*="/products/"]');
    for (var i = 0; i < links.length; i++) {
      if (productPath(links[i].href) === path) return links[i];
    }
    return null;
  }

  function maxScroll() {
    return Math.max(
      0,
      (document.documentElement.scrollHeight || document.body.scrollHeight || 0) - window.innerHeight
    );
  }

  function scrollToY(y) {
    var target = Math.min(Math.max(0, y), maxScroll());
    window.scrollTo(0, target);
    document.documentElement.scrollTop = target;
    document.body.scrollTop = target;
  }

  function neutralizeScrollTriggers() {
    document.querySelectorAll('.scroll-trigger').forEach(function (el) {
      el.classList.remove('scroll-trigger--offscreen');
      el.classList.add('scroll-trigger--cancel');
    });
  }

  function applyRestore(data) {
    if (!data) return;

    var y = Number(data.y) || 0;
    if (y < 1 && !data.anchor) return;

    var userTouched = false;
    function markTouched() {
      userTouched = true;
      cleanup();
    }
    function cleanup() {
      window.removeEventListener('wheel', markTouched);
      window.removeEventListener('touchstart', markTouched);
      window.removeEventListener('keydown', markTouched);
    }

    window.addEventListener('wheel', markTouched, { passive: true });
    window.addEventListener('touchstart', markTouched, { passive: true });
    window.addEventListener('keydown', markTouched);

    neutralizeScrollTriggers();

    function tick() {
      if (userTouched) return;
      neutralizeScrollTriggers();
      scrollToY(y);

      var current = window.scrollY || window.pageYOffset || 0;
      if (Math.abs(current - y) > 140 && data.anchor) {
        var el = findAnchor(data.anchor);
        if (el) {
          try {
            el.scrollIntoView({ block: 'center', inline: 'nearest' });
          } catch (e) {
            var top = el.getBoundingClientRect().top + (window.scrollY || 0) - window.innerHeight * 0.35;
            scrollToY(top);
          }
        }
      }
    }

    [0, 16, 50, 100, 200, 400, 700, 1100, 1800, 2800].forEach(function (ms) {
      setTimeout(tick, ms);
    });

    var root = document.getElementById('ProductGridContainer') || document.querySelector('main') || document;
    var imgs = root.querySelectorAll('img');
    imgs.forEach(function (img) {
      if (img.complete) return;
      img.addEventListener('load', tick, { once: true });
      img.addEventListener('error', tick, { once: true });
    });

    if (window.ResizeObserver) {
      var ro = new ResizeObserver(function () {
        if (!userTouched) tick();
      });
      if (document.body) ro.observe(document.body);
      setTimeout(function () {
        try {
          ro.disconnect();
        } catch (e) {}
      }, 3000);
    }

    setTimeout(cleanup, 3200);
  }

  function shouldRestore(persisted) {
    if (isProductPath(location.pathname)) return false;

    var pending = null;
    try {
      pending = sessionStorage.getItem(PENDING);
    } catch (e) {}

    var key = pageKey();
    var nav = performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
    var isBack = !!(persisted || (nav && nav.type === 'back_forward'));

    if (pending === key || isBack) {
      remove(PENDING);
      return true;
    }
    return false;
  }

  function maybeRestore(persisted) {
    if (!shouldRestore(persisted)) return;
    applyRestore(read(PREFIX + pageKey()));
  }

  document.addEventListener(
    'click',
    function (e) {
      var a = e.target && e.target.closest ? e.target.closest('a[href*="/products/"]') : null;
      if (!a) return;
      if (a.hasAttribute('download') || a.target === '_blank') return;
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      if (isProductPath(location.pathname)) return;
      saveNow(a.href);
      markPending();
    },
    true
  );

  window.addEventListener('pagehide', function () {
    if (!isProductPath(location.pathname)) saveNow();
  });

  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'hidden' && !isProductPath(location.pathname)) saveNow();
  });

  window.addEventListener('pageshow', function (e) {
    maybeRestore(!!e.persisted);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      maybeRestore(false);
    });
  } else {
    maybeRestore(false);
  }
})();
